<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.userGroups.editUserGroup') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/grupy-uzytkownikow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">{{ $t('ui.saveChanges') }}</d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form v-if="allDataLoaded">
      <d-card class="mb-5">
        <d-tabs v-sticky-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer
              v-if="loaded"
              ref="user-group-edit-form"
              tag="form" >
              <div class="form-group">
                <label for="name">
                  {{ $t('settings.userGroups.groupName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>

            <div
              v-if="!loaded"
              class="pb-3 pt-3 text-center">
              {{ $t('ui.dataLoading') }}&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>

    <div
      v-if="!allDataLoaded"
      class="pb-3 pt-3 text-center overlay-loading">
        {{ $t('ui.dataLoading') }}&hellip;
    </div>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'user-group-edit',
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data() {
    return {
      id: 0,
      name: '',
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    FormUtils.loadItemData(this, {
      endpointBase: '/users/groups/item/',
      instanceFields: ['name'],
      loadedKey: 'loaded'
    });
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['user-group-edit-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/users/groups/update/' + this.id,
        formData: {
          name: this.name,
        },
        successTitle: this.$t('settings.userGroups.editUserGroupSuccessTitle'),
        successText: this.$t('settings.userGroups.editUserGroupSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.userGroups.editUserGroupErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/grupy-uzytkownikow')
        }
      });
    }
  }
};
</script>
